export const actionTypes = {
  IsLoggedIn: 'IsLoggedIn',

  RESET_PASSWORD_LOADER: 'RESET_PASSWORD_LOADER',
  RESET_PASSWORD_GET_OTP_SUCCESS: 'RESET_PASSWORD_GET_OTP_SUCCESS',
  RESET_PASSWORD_GET_OTP_FAILURE: 'RESET_PASSWORD_GET_OTP_FAILURE',

  CLEAR_PWD_DATA: 'CLEAR_PWD_DATA',
};
